import type { ReactElement } from "react";

import type { ChipItem } from "app/pages/sales-intelligence/common-components/filters-panel";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { LimitedChipItems } from "app/pages/sales-intelligence/common-components/filters-panel";
import { FilterResultContainer } from "app/pages/sales-intelligence/common-components/filters-panel/components/styles";
import { MAX_CHIPS_GROUP_AMOUNT } from "app/pages/sales-intelligence/modules/leads-search-filters/constants";
import type { Profile } from "app/pages/sales-intelligence/sub-modules/contacts-search-profiles/types/common";

import type EmployeePersonasFilterModel from "../../../models/EmployeePersonasFilter/EmployeePersonasFilterModel";

const EmployeeProfilesFilterResult = ({
    value = [],
    filter,
    isExpanded,
    isActionEnabled = true,
    onGetLifecycleStatus,
    onFilterUpdate,
    onFilterValueRemove,
}: IFilterViewBaseProps<EmployeePersonasFilterModel>): ReactElement | null => {
    const enabledNotEmptyProfiles = filter.getEnabledNotEmptyProfiles(value);

    const handleRemove = (id: string) => {
        const newValue = value.map((v) => (v.id === id ? { ...v, isEnabled: false } : v));
        onFilterUpdate(newValue);
        onFilterValueRemove?.(newValue);
    };

    const chipItems: ChipItem[] = enabledNotEmptyProfiles.map((profile: Profile) => ({
        id: profile.id,
        text: profile.name,
        chipStatus: onGetLifecycleStatus?.(profile.id),
    }));

    if (!chipItems?.length) {
        return null;
    }

    return (
        <FilterResultContainer>
            <LimitedChipItems
                items={chipItems}
                onDelete={handleRemove}
                maxItems={MAX_CHIPS_GROUP_AMOUNT}
                hideActionButton={!isActionEnabled}
                isTabExpanded={isExpanded}
            />
        </FilterResultContainer>
    );
};

export default EmployeeProfilesFilterResult;
